var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _controller, _scale, _initialDistance, _startScale, _translate, _startPosition, _startTranslate, _isDragging, _initialized, _animationFrame, _lastTapTime, _lastTapPosition, _hasDraggedBeyondThreshold, _hasManualZoom, _DragZoomWrapper_instances, image_get, initResizeListener_fn, initEventListeners_fn, _handleResize, _resizeObserver, _handleTouchStart, startZoomGestureFromTouches_fn, startDragGestureFromTouch_fn, storeTapInfo_fn, handleDoubleTapFromTouch_fn, _handleTouchMove, processZoomGesture_fn, processDragGesture_fn, _handleTouchEnd, constrainTranslation_fn, _requestUpdateTransform, cancelAnimationFrame_fn, _updateTransform, _resetZoom;
import { DialogCloseEvent } from "./dialog.js";
import { clamp, preventDefault, isMobileBreakpoint } from "./utilities.js";
import { Component } from "@theme/component";
const MIN_ZOOM = 1;
const MAX_ZOOM = 5;
const DEFAULT_ZOOM = 1.5;
const DOUBLE_TAP_DELAY = 300;
const DOUBLE_TAP_DISTANCE = 50;
const DRAG_THRESHOLD = 10;
class DragZoomWrapper extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _DragZoomWrapper_instances);
    __publicField(this, "requiredRefs", ["image"]);
    __privateAdd(this, _controller, new AbortController());
    /** @type {number} */
    __privateAdd(this, _scale, DEFAULT_ZOOM);
    /** @type {number} */
    __privateAdd(this, _initialDistance, 0);
    /** @type {number} */
    __privateAdd(this, _startScale, DEFAULT_ZOOM);
    /** @type {Point} */
    __privateAdd(this, _translate, { x: 0, y: 0 });
    /** @type {Point} */
    __privateAdd(this, _startPosition, { x: 0, y: 0 });
    /** @type {Point} */
    __privateAdd(this, _startTranslate, { x: 0, y: 0 });
    /** @type {boolean} */
    __privateAdd(this, _isDragging, false);
    /** @type {boolean} */
    __privateAdd(this, _initialized, false);
    /** @type {number | null} */
    __privateAdd(this, _animationFrame, null);
    /** @type {number} */
    __privateAdd(this, _lastTapTime, 0);
    /** @type {Point | null} */
    __privateAdd(this, _lastTapPosition, null);
    /** @type {boolean} */
    __privateAdd(this, _hasDraggedBeyondThreshold, false);
    /** @type {boolean} */
    __privateAdd(this, _hasManualZoom, false);
    __privateAdd(this, _handleResize, () => {
      if (!__privateGet(this, _initialized) && isMobileBreakpoint()) {
        __privateMethod(this, _DragZoomWrapper_instances, initEventListeners_fn).call(this);
      }
      if (__privateGet(this, _initialized)) {
        __privateGet(this, _requestUpdateTransform).call(this);
      }
    });
    __privateAdd(this, _resizeObserver, new ResizeObserver(__privateGet(this, _handleResize)));
    /**
     * @param {TouchEvent} event
     */
    __privateAdd(this, _handleTouchStart, (event) => {
      preventDefault(event);
      const touchCount = event.touches.length;
      if (touchCount === 2) {
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        if (!touch1 || !touch2) return;
        __privateMethod(this, _DragZoomWrapper_instances, startZoomGestureFromTouches_fn).call(this, touch1, touch2);
      } else if (touchCount === 1) {
        const touch = event.touches[0];
        if (!touch) return;
        const currentTime = performance.now();
        const timeSinceLastTap = currentTime - __privateGet(this, _lastTapTime);
        if (timeSinceLastTap >= DOUBLE_TAP_DELAY) {
          __privateMethod(this, _DragZoomWrapper_instances, storeTapInfo_fn).call(this, currentTime, touch);
          __privateMethod(this, _DragZoomWrapper_instances, startDragGestureFromTouch_fn).call(this, touch);
          return;
        }
        if (__privateGet(this, _lastTapPosition)) {
          const distance = getDistance(touch, __privateGet(this, _lastTapPosition));
          if (distance < DOUBLE_TAP_DISTANCE) {
            __privateMethod(this, _DragZoomWrapper_instances, handleDoubleTapFromTouch_fn).call(this, touch);
            __privateSet(this, _lastTapTime, 0);
            __privateSet(this, _lastTapPosition, null);
            return;
          }
        }
        __privateMethod(this, _DragZoomWrapper_instances, storeTapInfo_fn).call(this, currentTime, touch);
        __privateMethod(this, _DragZoomWrapper_instances, startDragGestureFromTouch_fn).call(this, touch);
      }
    });
    /**
     * @param {TouchEvent} event
     */
    __privateAdd(this, _handleTouchMove, (event) => {
      preventDefault(event);
      const touchCount = event.touches.length;
      if (touchCount === 2) {
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        if (touch1 && touch2) {
          __privateMethod(this, _DragZoomWrapper_instances, processZoomGesture_fn).call(this, touch1, touch2);
        }
      } else if (touchCount === 1 && __privateGet(this, _isDragging)) {
        const touch = event.touches[0];
        if (touch) {
          __privateMethod(this, _DragZoomWrapper_instances, processDragGesture_fn).call(this, touch);
        }
      }
    });
    /**
     * @param {TouchEvent} event
     */
    __privateAdd(this, _handleTouchEnd, (event) => {
      if (event.touches.length === 0) {
        __privateSet(this, _isDragging, false);
        __privateGet(this, _requestUpdateTransform).call(this);
        __privateSet(this, _hasDraggedBeyondThreshold, false);
      }
    });
    /**
     * Request an animation frame to update the transform
     */
    __privateAdd(this, _requestUpdateTransform, () => {
      if (!__privateGet(this, _animationFrame)) {
        __privateSet(this, _animationFrame, requestAnimationFrame(__privateGet(this, _updateTransform)));
      }
    });
    __privateAdd(this, _updateTransform, () => {
      __privateSet(this, _animationFrame, null);
      __privateMethod(this, _DragZoomWrapper_instances, constrainTranslation_fn).call(this);
      this.style.setProperty("--drag-zoom-scale", __privateGet(this, _scale).toString());
      this.style.setProperty("--drag-zoom-translate-x", `${__privateGet(this, _translate).x}px`);
      this.style.setProperty("--drag-zoom-translate-y", `${__privateGet(this, _translate).y}px`);
    });
    /**
     * Reset zoom to default state (1.5x scale, centered position)
     * Called when zoom is exited/closed
     */
    __privateAdd(this, _resetZoom, () => {
      __privateSet(this, _scale, DEFAULT_ZOOM);
      __privateSet(this, _startScale, DEFAULT_ZOOM);
      __privateGet(this, _translate).x = 0;
      __privateGet(this, _translate).y = 0;
      __privateSet(this, _startPosition, { x: 0, y: 0 });
      __privateSet(this, _startTranslate, { x: 0, y: 0 });
      __privateSet(this, _isDragging, false);
      __privateSet(this, _lastTapTime, 0);
      __privateSet(this, _lastTapPosition, null);
      __privateSet(this, _hasDraggedBeyondThreshold, false);
      this.style.setProperty("--drag-zoom-scale", DEFAULT_ZOOM.toString());
      this.style.setProperty("--drag-zoom-translate-x", "0px");
      this.style.setProperty("--drag-zoom-translate-y", "0px");
    });
  }
  connectedCallback() {
    super.connectedCallback();
    if (!__privateGet(this, _DragZoomWrapper_instances, image_get)) return;
    __privateMethod(this, _DragZoomWrapper_instances, initResizeListener_fn).call(this);
    window.addEventListener(DialogCloseEvent.eventName, __privateGet(this, _resetZoom));
    if (!isMobileBreakpoint()) return;
    __privateMethod(this, _DragZoomWrapper_instances, initEventListeners_fn).call(this);
    __privateGet(this, _updateTransform).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener(DialogCloseEvent.eventName, __privateGet(this, _resetZoom));
    __privateGet(this, _controller).abort();
    __privateGet(this, _resizeObserver).disconnect();
    __privateMethod(this, _DragZoomWrapper_instances, cancelAnimationFrame_fn).call(this);
  }
  destroy() {
    __privateGet(this, _controller).abort();
    __privateMethod(this, _DragZoomWrapper_instances, cancelAnimationFrame_fn).call(this);
  }
}
_controller = new WeakMap();
_scale = new WeakMap();
_initialDistance = new WeakMap();
_startScale = new WeakMap();
_translate = new WeakMap();
_startPosition = new WeakMap();
_startTranslate = new WeakMap();
_isDragging = new WeakMap();
_initialized = new WeakMap();
_animationFrame = new WeakMap();
_lastTapTime = new WeakMap();
_lastTapPosition = new WeakMap();
_hasDraggedBeyondThreshold = new WeakMap();
_hasManualZoom = new WeakMap();
_DragZoomWrapper_instances = new WeakSet();
image_get = function() {
  return this.refs.image;
};
initResizeListener_fn = function() {
  __privateGet(this, _resizeObserver).observe(this);
};
initEventListeners_fn = function() {
  if (__privateGet(this, _initialized)) return;
  __privateSet(this, _initialized, true);
  const { signal } = __privateGet(this, _controller);
  const options = { passive: false, signal };
  this.addEventListener("touchstart", __privateGet(this, _handleTouchStart), options);
  this.addEventListener("touchmove", __privateGet(this, _handleTouchMove), options);
  this.addEventListener("touchend", __privateGet(this, _handleTouchEnd), options);
  __privateGet(this, _updateTransform).call(this);
};
_handleResize = new WeakMap();
_resizeObserver = new WeakMap();
_handleTouchStart = new WeakMap();
/**
 * Start a zoom gesture with two touches
 * @param {Touch} touch1
 * @param {Touch} touch2
 */
startZoomGestureFromTouches_fn = function(touch1, touch2) {
  __privateSet(this, _initialDistance, getDistance(touch1, touch2));
  __privateSet(this, _startScale, __privateGet(this, _scale));
  __privateSet(this, _isDragging, false);
};
/**
 * Start a drag gesture with a single touch
 * @param {Touch} touch
 */
startDragGestureFromTouch_fn = function(touch) {
  __privateSet(this, _startPosition, { x: touch.clientX, y: touch.clientY });
  __privateSet(this, _startTranslate, { x: __privateGet(this, _translate).x, y: __privateGet(this, _translate).y });
  __privateSet(this, _isDragging, true);
  __privateSet(this, _hasDraggedBeyondThreshold, false);
};
/**
 * Store tap information for double-tap detection
 * @param {number} currentTime
 * @param {Touch} touch
 */
storeTapInfo_fn = function(currentTime, touch) {
  __privateSet(this, _lastTapTime, currentTime);
  __privateSet(this, _lastTapPosition, { x: touch.clientX, y: touch.clientY });
};
/**
 * Handle double-tap zoom toggle from touch
 * @param {Touch} touch - The touch where the double-tap occurred
 */
handleDoubleTapFromTouch_fn = function(touch) {
  const containerCenter = {
    x: this.clientWidth / 2,
    y: this.clientHeight / 2
  };
  let targetZoom;
  if (__privateGet(this, _hasManualZoom)) {
    targetZoom = MIN_ZOOM;
    __privateSet(this, _hasManualZoom, false);
    __privateSet(this, _translate, { x: 0, y: 0 });
  } else {
    const tolerance = 0.05;
    if (Math.abs(__privateGet(this, _scale) - MIN_ZOOM) < tolerance) {
      targetZoom = DEFAULT_ZOOM;
    } else {
      targetZoom = MIN_ZOOM;
    }
  }
  if (targetZoom !== MIN_ZOOM) {
    const oldScale = __privateGet(this, _scale);
    __privateSet(this, _scale, Math.min(MAX_ZOOM, targetZoom));
    const distanceFromCenter = {
      x: touch.clientX - containerCenter.x,
      y: touch.clientY - containerCenter.y
    };
    const scaleDelta = __privateGet(this, _scale) / oldScale - 1;
    __privateGet(this, _translate).x -= distanceFromCenter.x * scaleDelta / __privateGet(this, _scale);
    __privateGet(this, _translate).y -= distanceFromCenter.y * scaleDelta / __privateGet(this, _scale);
  } else {
    __privateSet(this, _scale, targetZoom);
    __privateSet(this, _translate, { x: 0, y: 0 });
  }
  __privateGet(this, _requestUpdateTransform).call(this);
};
_handleTouchMove = new WeakMap();
/**
 * Process zoom gesture from touches
 * @param {Touch} touch1
 * @param {Touch} touch2
 */
processZoomGesture_fn = function(touch1, touch2) {
  const midX = (touch1.clientX + touch2.clientX) / 2;
  const midY = (touch1.clientY + touch2.clientY) / 2;
  const currentDistance = getDistance(touch1, touch2);
  const oldScale = __privateGet(this, _scale);
  const newScale = currentDistance / __privateGet(this, _initialDistance) * __privateGet(this, _startScale);
  __privateSet(this, _scale, clamp(newScale, MIN_ZOOM, MAX_ZOOM));
  __privateSet(this, _hasManualZoom, true);
  const containerCenterX = this.clientWidth / 2;
  const containerCenterY = this.clientHeight / 2;
  const distanceFromCenterX = midX - containerCenterX;
  const distanceFromCenterY = midY - containerCenterY;
  const scaleDelta = __privateGet(this, _scale) / oldScale - 1;
  __privateGet(this, _translate).x -= distanceFromCenterX * scaleDelta / __privateGet(this, _scale);
  __privateGet(this, _translate).y -= distanceFromCenterY * scaleDelta / __privateGet(this, _scale);
  __privateGet(this, _requestUpdateTransform).call(this);
  __privateSet(this, _isDragging, false);
};
/**
 * Process drag gesture from touch
 * @param {Touch} touch
 */
processDragGesture_fn = function(touch) {
  const distance = getDistance(touch, __privateGet(this, _startPosition));
  if (!__privateGet(this, _hasDraggedBeyondThreshold) && distance < DRAG_THRESHOLD) {
    return;
  }
  __privateSet(this, _hasDraggedBeyondThreshold, true);
  const dx = touch.clientX - __privateGet(this, _startPosition).x;
  const dy = touch.clientY - __privateGet(this, _startPosition).y;
  __privateGet(this, _translate).x = __privateGet(this, _startTranslate).x + dx / __privateGet(this, _scale);
  __privateGet(this, _translate).y = __privateGet(this, _startTranslate).y + dy / __privateGet(this, _scale);
  __privateGet(this, _requestUpdateTransform).call(this);
};
_handleTouchEnd = new WeakMap();
/**
 * Constrain image translation to keep it within the viewport
 */
constrainTranslation_fn = function() {
  const containerWidth = this.clientWidth;
  const containerHeight = this.clientHeight;
  if (!containerWidth || !containerHeight || !__privateGet(this, _DragZoomWrapper_instances, image_get)) return;
  __privateSet(this, _scale, clamp(__privateGet(this, _scale), MIN_ZOOM, MAX_ZOOM));
  if (__privateGet(this, _scale) <= MIN_ZOOM) {
    __privateGet(this, _translate).x = 0;
    __privateGet(this, _translate).y = 0;
    return;
  }
  const wrapperRect = this.getBoundingClientRect();
  const imageElement = __privateGet(this, _DragZoomWrapper_instances, image_get);
  let naturalWidth, naturalHeight;
  if (imageElement.naturalWidth > 0 && imageElement.naturalHeight > 0) {
    naturalWidth = imageElement.naturalWidth;
    naturalHeight = imageElement.naturalHeight;
  } else {
    naturalWidth = wrapperRect.width;
    naturalHeight = wrapperRect.width;
  }
  const imageAspectRatio = naturalWidth / naturalHeight;
  const wrapperAspectRatio = wrapperRect.width / wrapperRect.height;
  let actualImageWidth, actualImageHeight;
  if (imageAspectRatio > wrapperAspectRatio) {
    actualImageWidth = wrapperRect.width;
    actualImageHeight = actualImageWidth / imageAspectRatio;
  } else {
    actualImageHeight = wrapperRect.height;
    actualImageWidth = actualImageHeight * imageAspectRatio;
  }
  const scaledImageWidth = actualImageWidth * __privateGet(this, _scale);
  const scaledImageHeight = actualImageHeight * __privateGet(this, _scale);
  const horizontalOverflow = Math.max(0, scaledImageWidth - wrapperRect.width);
  const verticalOverflow = Math.max(0, scaledImageHeight - wrapperRect.height);
  const maxTranslateX = horizontalOverflow / 2 / __privateGet(this, _scale);
  const maxTranslateY = verticalOverflow / 2 / __privateGet(this, _scale);
  __privateGet(this, _translate).x = clamp(__privateGet(this, _translate).x, -maxTranslateX, maxTranslateX);
  __privateGet(this, _translate).y = clamp(__privateGet(this, _translate).y, -maxTranslateY, maxTranslateY);
  this.style.setProperty("--drag-zoom-scale", __privateGet(this, _scale).toString());
  this.style.setProperty("--drag-zoom-translate-x", `${__privateGet(this, _translate).x}px`);
  this.style.setProperty("--drag-zoom-translate-y", `${__privateGet(this, _translate).y}px`);
};
_requestUpdateTransform = new WeakMap();
/**
 * Cancel any pending animation frame
 */
cancelAnimationFrame_fn = function() {
  if (__privateGet(this, _animationFrame)) {
    cancelAnimationFrame(__privateGet(this, _animationFrame));
    __privateSet(this, _animationFrame, null);
  }
};
_updateTransform = new WeakMap();
_resetZoom = new WeakMap();
function getDistance(point1, point2) {
  const x1 = (
    /** @type {Point} */
    point1.x ?? /** @type {Touch} */
    point1.clientX
  );
  const y1 = (
    /** @type {Point} */
    point1.y ?? /** @type {Touch} */
    point1.clientY
  );
  const x2 = (
    /** @type {Point} */
    point2.x ?? /** @type {Touch} */
    point2.clientX
  );
  const y2 = (
    /** @type {Point} */
    point2.y ?? /** @type {Touch} */
    point2.clientY
  );
  const dx = x1 - x2;
  const dy = y1 - y2;
  return Math.sqrt(dx * dx + dy * dy);
}
if (!customElements.get("drag-zoom-wrapper")) {
  customElements.define("drag-zoom-wrapper", DragZoomWrapper);
}
export {
  DragZoomWrapper
};
